import React from 'react';
import { PlayBadge } from '../../../../PlayBadge/PlayBadge';

const OpenArchiveBadge = ({ openArchive, location, theme }) => {
    if (!openArchive) {
        return null;
    }

    /* No badges on genre/oppet-arkiv */
    if (location && location.includes('oppet-arkiv')) {
        return null;
    }

    return <PlayBadge text="Öppet Arkiv" accessibilityText="Öppet Arkiv" theme={theme} overlay />;
};

export default OpenArchiveBadge;
